import * as t from 'io-ts';
export var nullable = function nullable(c) {
  return t.union([c, t["null"]]);
};